import { gql } from "@apollo/client";

export const SUBMIT_USER_GAME = gql`
  mutation SubmitUserGame (
    $userId: String!
    $date: String!
    $mode: String!
    $tiles: [String!]!
    $elapsedTime: Int!
  ) {
    submitUserGame(
      input: {
        input: {
          userId: $userId,
          date: $date,
          mode: $mode,
          elapsedTime: $elapsedTime,
          tiles: $tiles
        }
      }
    ) {
        errors
        solved
        success
        streak
        maxStreak
        offerClaim
        wins
        showRank
        timePercentile
    }
  }
`;

export const DECLINE_OFFER = gql`
  mutation DeclineOffer($userId: String!) {
    declineOffer(userId: $userId)
  }
`;

export const START_USER_GAME = gql`
  mutation StartUserGame(
    $userId: String!
    $date: String!
    $mode: String!
  ) {
    startUserGame(
      input: {
        input: {
          userId: $userId
          date: $date
          mode: $mode
        }
      }
    ) {
      success
      errors
    }
  }
`;

export const RECORD_USER_GAME_HINT = gql`
  mutation RecordUserGameHint(
    $userId: String!
    $date: String!
    $mode: String!
    $hintNumber: Int!
    $elapsedTime: Int!
  ) {
    recordUserGameHint(
      input: {
        input: {
          userId: $userId
          date: $date
          mode: $mode
          hintNumber: $hintNumber
          elapsedTime: $elapsedTime
        }
      }
    ) {
      success
      errors
    }
  }
`;

